import type { LocalReport, PlanningItem, ReportOption } from './types';

export type ReportTarget = Pick<PlanningItem, 'project_id' | 'project_name' | 'date'>;

export function assignedReports(reports: LocalReport[], planning: PlanningItem[]): LocalReport[] {
  const projects = new Set(planning.map(item => item.project_id).filter(id => id != null));
  return reports.filter(report => projects.has(report.project_id));
}

export function reportsForTarget(reports: LocalReport[], target: ReportTarget): LocalReport[] {
  return reports.filter(report => report.project_id === target.project_id && report.report_date === target.date);
}

export function optionsForTarget(options: ReportOption[], target: ReportTarget): ReportOption[] {
  return options.filter(option => option.project_id === target.project_id && option.report_date === target.date);
}

export function mayEditReport(report: LocalReport, planning: PlanningItem[]): boolean {
  return (report.status === 'draft' || report.status === 'rejected') && report.can_edit !== false &&
    planning.some(item => item.project_id === report.project_id && item.date === report.report_date && item.is_leader);
}

export function existingReportForOption(reports: LocalReport[], option: ReportOption): LocalReport | undefined {
  return reports.find(report => report.project_id === option.project_id && report.report_date === option.report_date && report.template_id === option.template_id);
}
